import React from 'react';
import Spinner from 'react-spinkit';

export const FadingCircle = ({ color, size, style: styleProp, ...rest }) => {
  const style = { ...styleProp };
  if (color) style.color = color;
  if (size) style.fontSize = size;
  return <Spinner name="circle" style={Object.keys(style).length ? style : undefined} {...rest} />;
};

export default FadingCircle;
